/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartElement = document.querySelector('ajax-cart');

    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));

    this.addUpsellProducts = this.querySelectorAll('[data-addUpsellProduct]');
    this.addUpsellProducts.forEach(addUpsell => addUpsell.addEventListener('click', this.addUpsellProduct.bind(this)));

    this.swatchLabelImg = this.querySelectorAll('[data-swatchLabelImg]');
    this.swatchLabelImg.forEach(img => img.addEventListener('mouseover', this.updateSwatchLabelOver.bind(this)));
    this.swatchLabelImg.forEach(img => img.addEventListener('mouseout', this.updateSwatchLabelOut.bind(this)));
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    console.log('quantity => ' + qtyInput.value);
    const pdpContainer = this.closest('.product-details-wrapper');
    const MainId = this.querySelector('[name="id"]').value;
    
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    addItems.push(JSON.parse(serializeForm(this.form)));

    console.log('addItems payload:', addItems);

    if (pdpContainer) {
      let addOnItemsEle = pdpContainer.querySelectorAll('[data-addon-selection]:checked');
      addOnItemsEle.forEach((addOn) => {
        if (!addOn.disabled) {
          let addOnParent = addOn.closest('addons-form');
          let addOnJSON = {
            id: addOnParent.querySelector('.variant--id').value,
            quantity: addOnParent.querySelector('.product-quantity').value
          }
          addItems.push(addOnJSON);
        }
      });
      // for bundle products
       if(pdpContainer.querySelectorAll('[data-bundle-selection]').length > 0) {
        let bundleItemsEle = pdpContainer.querySelectorAll('[data-bundle-selection]');
  
        bundleItemsEle.forEach((bundle)=>{
          let bundleParent = bundle.querySelector('.variant--id').value;
          let bundleJSON = {
            id: bundleParent,
            quantity: qtyInput.value,
            properties: {_productType: "subProduct", _mainProductId: MainId }
          }
          addItems.push(bundleJSON);
        });
      }
    }

    const randomNum = Date.now() + 1;
    let divBuildYourOwnStack  = document.querySelector('[data-build-your-own-stack]');
    if (divBuildYourOwnStack) { 
      const selectedProducts = this.querySelectorAll('[data-product]');
      let sidebarDiscount = '';
      if (this.querySelector('[data-sidebarDiscount]') != null) {
        sidebarDiscount = this.querySelector('[data-sidebarDiscount]').getAttribute('data-sidebarDiscount');
      }
      addItems.length = 0;
      selectedProducts.forEach(element => { 
        if(element.getAttribute('data-productFlag') == 'true'){  
          var bundleJSON = {};
          if (sidebarDiscount != '') {
             bundleJSON = {
              id: element.querySelector('input').value,
              quantity: 1,
              properties: {
                product_type: "build-your-own-stack",
                discount: sidebarDiscount,
                connect: randomNum,
              }
            }
          } else {
             bundleJSON = {
              id: element.querySelector('input').value,
              quantity: 1,
              properties: {
                product_type: "build-your-own-stack",
                connect: randomNum,
              }
            }
          }
          addItems.push(bundleJSON);
          setTimeout(() => {
            element.querySelector('[data-removeProduct]').click();
          }, 1000);
        }
      });
    }

    // for bundle products
     if(pdpContainer && pdpContainer.querySelectorAll('[data-bundle-selection]').length > 0) {
      let bundleItemsEle = pdpContainer.querySelectorAll('[data-bundle-selection]');

      bundleItemsEle.forEach((bundle)=>{
        let bundleParent = bundle.querySelector('.variant--id').value;
        let bundleJSON = {
          id: bundleParent,
          quantity: qtyInput.value,
          properties: {_productType: "subProduct", _mainProductId: MainId }
        }
        addItems.push(bundleJSON);
    });
    }
    
    const body = JSON.stringify({
      items: addItems
    });


console.log('Request body:', body);    

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((response) => {
        if (document.querySelector('#PopupModal-quickshop')) {
          document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
        }
        // this.cartElement.getCartData('open_drawer');
        if (qtyInput) qtyInput.value = 1;
        if(response.errors) {
          alert("Not enough qty selected.");
          return false;
        }
       // window.location = '/cart'; 
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;

    if (action == 'decrease' && currentQty <= 1) {
      return false;
    } else if (action == 'decrease') {
      finalQty = currentQty - 1;
    } else {
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
    if (finalQty > 1) {
      document.querySelector('[data-for="decrease"]').classList.remove('disabled');
    } else {
      document.querySelector('[data-for="decrease"]').classList.add('disabled');
    }
  }

  addUpsellProduct(event){
    let variantJSON = event.currentTarget.getAttribute('data-variantData');
    let variantData = JSON.parse(variantJSON);

    event.currentTarget.setAttribute('disabled', true);
    event.currentTarget.classList.add('loading');

    const body = JSON.stringify({
        id: variantData.id,
        quantity: 1
    });
    let fetchCart = fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body }});
    fetchCart.then(response => {
        return response.json();
    }).then(_response => {
        this.cartElement.getCartData('open_drawer');
    }).catch((e) => {
        console.error(e);
    });
  }

  updateSwatchLabelOver(event) { 
    event.currentTarget.closest('fieldset').querySelector('[data-swatchLabelName]').innerHTML = event.currentTarget.getAttribute('data-swatchLabelImg');
  }
  updateSwatchLabelOut(event) { 
    event.currentTarget.closest('fieldset').querySelector('[data-swatchLabelName]').innerHTML = event.currentTarget.getAttribute('data-swatchSelectedValue');
  }

}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    if (!this.form) {
      return false;
    }
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;

    if (this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
onVariantChange(_event) {
    //console.log('variant change!');
    this.setCurrentVariant();
    if (this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;

    if(this.closest('[data-allProductGrid]')){
    const allProductGrid = this.closest('[data-allProductGrid]');
      const currentVariantJSON = JSON.stringify(this.currentVariant);

      const addProduct = allProductGrid.querySelector('product-form [data-addProduct]');
      addProduct.setAttribute('data-variantData', currentVariantJSON);
      addProduct.setAttribute('data-variantImage', this.currentVariant.featured_image.src);

    if(this.currentVariant) { 
      this.renderProductInfo(this.currentVariant, allProductGrid);
      this._updateLinks(allProductGrid);

      if(this.currentVariant.available){
        if (allProductGrid.hasAttribute("data-selectedProductGrid")) {
          let selectedProductID = allProductGrid.getAttribute('data-selectedProductGrid'); 

          let selectedProductsDiv = document.querySelectorAll('[data-selectedProductsDiv]');
          selectedProductsDiv.forEach(div => {
            let totalPrice = 0;

            let selectedProducts = div.querySelectorAll('[data-product]');
            selectedProducts.forEach(element => {
              if(element.getAttribute('data-productFlag') == 'true'){
                let productID = element.querySelector('[data-removeProduct]').getAttribute('data-removeProduct');
                if(productID == selectedProductID){
                  allProductGrid.setAttribute('data-selectedProductGrid', this.currentVariant.id);
                  element.setAttribute('data-productPrice', this.currentVariant.price);
                  element.querySelector('input').value = this.currentVariant.id;
                  element.querySelector('[data-removeProduct]').setAttribute('data-removeProduct', this.currentVariant.id);
                  element.querySelector('[data-productSubTitle]').innerHTML = this.currentVariant.title; 
                  element.querySelector('[data-productImage]').innerHTML = `<img src='${this.currentVariant.featured_image.src}&width=82' loading='lazy' alt='${this.currentVariant.title}' width='82' height='82'>`;
                }
                totalPrice += parseInt(element.getAttribute('data-productPrice'));
              }
            });

            let totalDiscount = (totalPrice * 25) / 100;
            let finalPrice = totalPrice - totalDiscount;
            div.querySelector('[data-totalPrice]').innerHTML = Shopify.formatMoney(totalPrice, window.globalVariables.money_format);
            div.querySelector('[data-finalPrice]').innerHTML = Shopify.formatMoney(finalPrice, window.globalVariables.money_format);
            div.querySelector('[data-totalDiscount]').innerHTML = "-"+Shopify.formatMoney(totalDiscount, window.globalVariables.money_format);
          });
          addProduct.classList.add('d-none');
          allProductGrid.querySelector('[data-addedProduct]').classList.remove('d-none');
        }
        this.toggleAddButton('enable', addProduct);
      }else{
        this.toggleAddButton('disable', addProduct);
        if (allProductGrid.hasAttribute("data-selectedProductGrid")) {
          addProduct.classList.remove('d-none');
          allProductGrid.querySelector('[data-addedProduct]').classList.add('d-none');
        }
      }
    }else{
      this.toggleAddButton('disable', addProduct);
      if (allProductGrid.hasAttribute("data-selectedProductGrid")) {
        addProduct.classList.remove('d-none');
        allProductGrid.querySelector('[data-addedProduct]').classList.add('d-none');
      }
    }



  
    if(document.querySelector('[data-flavorcontentid="'+ this.currentVariant.id +'"]')){
      if(document.querySelector('[data-flavorcontentid="'+ this.currentVariant.id +'"]').classList.contains('no-supplement-img')){
        document.querySelector('[data-flavorcontentid="'+ this.currentVariant.id +'"]').closest('.accordion__container').classList.add('d-none')
      }else{
        document.querySelector('[data-flavorcontentid="'+ this.currentVariant.id +'"]').closest('.accordion__container').classList.remove('d-none')
      }
    }
  }

    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      
      // Variant name update
      let options = this.form.querySelectorAll('[data-optionindex]');
      options.forEach(option => {
        let lableID = 'option' + option.dataset.optionindex;
        const selectedValue = option.querySelector('input[type="radio"]:checked');
        const lable = option.querySelector('.selected-option');
        if (!lable || !lableID || !selectedValue) return;
        lable.innerHTML = selectedValue.value;
        let fieldsetLI = option.querySelectorAll('[data-swatchSelectedValue]');
        if (!fieldsetLI) return;
        fieldsetLI.forEach(li => {
          li.setAttribute('data-swatchSelectedValue', selectedValue.value)
        });
      });
    } else {
      if (this.formType == 'grid') {
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid);
        if (this.currentVariant.available == true) {
          productGrid.querySelector('[data-badge-stock]')?.classList.add('d-none');
        }else{
          if(productGrid.querySelector('[data-badge-stock]').classList.contains('d-none')){
            productGrid.querySelector('[data-badge-stock]').classList.remove('d-none');
          }
        }
      } else {
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      // console.log(this.currentVariant)
      const titleVar = this.currentVariant.title;
      document.querySelectorAll('[data-serving]').forEach(function(target) {
        if (target.getAttribute('data-serving') == titleVar) {
          target.classList.remove('d-none');
        } else {
          target.classList.add('d-none');
        }
      });

      
      //console.log('Current Variant ID:', this.currentVariant.id);

      // Select all video containers with data-var-video attribute
      const allVariantVideos = document.querySelectorAll('[data-var-video]');
      
      if (allVariantVideos.length) {
        allVariantVideos.forEach((videoDiv) => {
          // Toggle the 'd-none' class based on whether it matches the current variant ID
          if (videoDiv.getAttribute('data-var-video') === this.currentVariant.id.toString()) {
            videoDiv.classList.remove('d-none');
            //console.log('Displaying video for variant:', this.currentVariant.id);
          } else {
            videoDiv.classList.add('d-none');
          }
        });
      } else {
        console.warn('No video elements found with data-var-video attributes');
      }

      /*document.querySelectorAll('[data-supplementFactsImg]').forEach(function(target) {
        if (target.getAttribute('data-supplementFactsImg') == titleVar) {
          target.classList.remove('d-none');
        } else {
          target.classList.add('d-none');
        }
      });*/

console.log(`Current variant ID: ${this.currentVariant.id}`); // Log current variant ID

// Update visibility for .supp-facts-wrapper elements
document.querySelectorAll('.supp-facts-wrapper').forEach(wrapper => {
    const wrapperVariantId = wrapper.getAttribute('data-variant-id');
    if (wrapperVariantId === String(this.currentVariant.id)) {  // Convert both to strings
        // Show the matching wrapper
        wrapper.classList.remove('d-none');
        wrapper.classList.add('d-flex');
        //console.log(`Showing .supp-facts-wrapper for variant ID: ${this.currentVariant.id}`);
    } else {
        // Hide all other wrappers
        wrapper.classList.add('d-none');
        wrapper.classList.remove('d-flex');
        //console.log(`Hiding .supp-facts-wrapper for variant ID: ${wrapperVariantId}`);
    }
});
      
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');
    }
    if(_event != 'load' && this.form.querySelector('recharge-widget') != null)  rechargeWidget.prototype._toggleOptions(_event);
    

    var flavorOptionIDs = document.querySelectorAll('[data-flavorOptionID]');
    if(flavorOptionIDs){
      flavorOptionIDs.forEach(option => {
        option.classList.remove('selected');
        let flavorOptionID = option.getAttribute('data-flavorOptionID');
        if(flavorOptionID == this.currentVariant.id){
          option.classList.add('selected');
          let flavorOptionImage = option.getAttribute('data-flavorOptionImage');
          document.querySelector('[data-selectedFlavorTitle]').innerHTML = option.querySelector('.option_txt').innerHTML;
          if (flavorOptionImage && document.querySelector('[data-flavorFeauredImage]') != null) {
            console.log(flavorOptionImage, 'kajal');
            document.querySelector('[data-flavorFeauredImage]').src = flavorOptionImage;
          }
        }
      });
    }

    var flavorContentIDs = document.querySelectorAll('[data-flavorContentID]');
    if(flavorContentIDs){
      flavorContentIDs.forEach(content => {
        content.classList.add('d-none');
        var flavorContentID = content.getAttribute('data-flavorContentID');
        if(flavorContentID == this.currentVariant.id){
          content.classList.remove('d-none');
        }
      });
    }

  }
  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid) {
    if (!this.currentVariant || !productGrid) return;
    const variantURL = '?variant=' + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector) => {
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    console.log('radios!');
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    // console.log("options==>>",options)
    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if (!mappedValues.includes(false)) {
        this.currentVariant = variant;
      }
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if (this.formType == 'product-page') window.history.replaceState({}, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Render Product data based on current variant
   * @param {event} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {
    if (!currentVariant || !container) return;

    // Price Update
    let subscriptionCheckbox = container.querySelector('[data-subscription-checkbox]');
    if(subscriptionCheckbox != null && subscriptionCheckbox.checked){ 
      var price = Shopify.formatMoney(currentVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);
      var compare_price = Shopify.formatMoney(currentVariant.selling_plan_allocations[0].compare_at_price, window.globalVariables.money_format);
    }else{ 
      var price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format); 
      var compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    }
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');
    let saleBadge = container.querySelector('.badge-sale');
    
    if (priceElement)
      if(priceElement.hasAttribute('data-discount') && priceElement.getAttribute('data-discount') > 0){
        let discount = priceElement.getAttribute('data-discount')
        console.log(discount,'discount')
        let discount_price = currentVariant.price * discount
        let discountPrice = Shopify.formatMoney(discount_price, window.globalVariables.money_format);
        priceElement.innerHTML =  discountPrice + `<s class="ms-2 text-gray-400 me-2 money fw-medium">${price}</s>`
      }else{
        priceElement.innerHTML = price;
      }

      try{
        priceElement.classList.remove("wpd-processed");
        priceElement.setAttribute("data-wpd-variant-compare-at-price",currentVariant.compare_at_price == null ? "":currentVariant.compare_at_price);
        priceElement.setAttribute("data-wpd-variant-price",currentVariant.price);
        priceElement.setAttribute("data-wpd-variant-id",currentVariant.id);
        priceElement.setAttribute("data-wpd-product-handle",window.wpdExtensionIsProductPage.handle);
      }catch(e){}


    if (comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if (currentVariant.compare_at_price <= 0 || price == compare_price) {
        comparePriceElement.style.display = 'none';
        if (saleBadge)
          saleBadge.style.display = 'none';
        priceElement.classList.remove('twoprice');
      } else {
        comparePriceElement.style.display = 'inline';
        if (saleBadge)
          saleBadge.style.display = 'inline';
        priceElement.classList.add('twoprice');
      }
    }

    // Grid Image Update on variant selection
    if (this.formType == 'grid') {
      if (!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src.replace('.png', '_300x.png');
      if (updatedSrc) {
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    } else {
      if (!currentVariant.featured_image) return;
      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(`.product--media[data-mediaID="${imageID}"]`);
      if (this.formType == 'quickshop') {
        imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${imageID}"]`);
      }
      if (!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      if (quickShopSlider) quickShopSlider.slideTo(slideIndex, 1200, true);
      else if (productSlider) productSlider.slideTo(slideIndex, 1200, true);
    }

    // Variant name update
    let options = this.form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let lableID = 'option' + option.dataset.optionindex;
      const lable = option.querySelector('.selected-option');
      if (!lable || !lableID) return;
      lable.innerHTML = currentVariant[lableID];
      let fieldsetLI = option.querySelectorAll('[data-swatchSelectedValue]');
      if (!fieldsetLI) return;
      fieldsetLI.forEach(li => {
        li.setAttribute('data-swatchSelectedValue', currentVariant[lableID])
      });
    });
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if (this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
    } else if (this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if (this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.outOfStock;
        // this.addBtn.querySelector('.add-text').textContent = window.variantStrings.notify_me;
    } else {
      this.addBtn.removeAttribute('disabled');
      if (this.form.classList.contains('cart-upsell-form')) {
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
      } else {
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      }
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    // const colorSwatchContainer = this.querySelector('.color-swatch');
    const colorSwatchContainer = this.querySelector('.img-swatch');
    if (colorSwatchContainer) {
      // const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      const colorSwatches = this.querySelectorAll('.img-swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        // swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
        if( swatch.querySelector('.swatch-label img') ){
          let metafieldsImg = swatch.querySelector('.swatch-label img').dataset.metafieldsImg;
          if(swatchStyle != false && metafieldsImg == "false"){
            swatch.querySelector('.swatch-label img').setAttribute('src', swatchStyle);
          }
        }
      });
    }
  }
}
customElements.define('variant-radios', VariantRadios);

class UpdateFlavorContent { 
  constructor() { 

    this.flavorOptionIDs = document.querySelectorAll('[data-flavorOptionID]');
    if (this.flavorOptionIDs) this.flavorOptionIDs.forEach(option => option.addEventListener('change', this.updateFlavorContent.bind(this)));

  }

  updateFlavorContent(event) { 
    let currentTarget = event.currentTarget;

    let flavorOptionID = currentTarget.getAttribute('data-flavorOptionID');
    let flavorOptionImage = currentTarget.getAttribute('data-flavorOptionImage');
    let flavorContentIDs = document.querySelectorAll('[data-flavorContentID]');
    if(flavorContentIDs){
      flavorContentIDs.forEach(content => {
        if(content.classList.contains('no-supplement-img')){
          // console.log(content.closest('.accordion__container'))
          content.closest('.accordion__container').classList.add('d-none')
        }
        content.classList.add('d-none');
        var flavorContentID = content.getAttribute('data-flavorContentID');
        if(flavorContentID == flavorOptionID && !content.classList.contains('no-supplement-img')){
          content.closest('.accordion__container').classList.remove('d-none')
          content.classList.remove('d-none');
        }
      });
    }
    if (flavorOptionImage && document.querySelector('[data-flavorFeauredImage]') != null) {
      document.querySelector('[data-flavorFeauredImage]').src = flavorOptionImage;
    }
  }

}
new UpdateFlavorContent();

class rechargeWidget extends HTMLElement {
  constructor() {
    super();

    const onetimeRadio = this.querySelector('[data-onetime-radio]');
    if(onetimeRadio) onetimeRadio.addEventListener('click', this._toggleOptions.bind(this));

    const subscriptionRadio = this.querySelector('[data-subscription-radio]');
    if(subscriptionRadio) subscriptionRadio.addEventListener('click', this._toggleOptions.bind(this));

    const sellingPlans = this.querySelectorAll('[data-purchase_type="subscription"] select');
    sellingPlans.forEach(plan => plan.addEventListener('change', this._changeSellingPlan.bind(this)));

    // const optionSelectors = this.querySelectorAll('[data-purchase_type]');
    // optionSelectors.forEach(option => option.addEventListener('click', this._toggleOptions.bind(this)));

    const subscriptionCheckbox = this.querySelector('[data-subscription-checkbox]');
    if(subscriptionCheckbox) subscriptionCheckbox.addEventListener('change', this._changeCheckbox.bind(this));
  }

  _toggleOptions(event){
    let currentTarget = event.currentTarget;
    let rechargeWidget = currentTarget.closest('recharge-widget');
    if (rechargeWidget && rechargeWidget != null) {
      let subscriptionSelect = rechargeWidget.querySelector('[data-subscription-select]');
      let sellingPlanId = rechargeWidget.querySelector('[name="selling_plan"]:checked').value;
      let type = currentTarget.getAttribute('data-purchase_type');
      if (type == 'onetime') {
        if (subscriptionSelect) {
          subscriptionSelect.classList.add('d-none');
          subscriptionSelect.querySelector('option').selected = true;
          subscriptionSelect.closest('[data-subscription-radio]').querySelector('[name="selling_plan"]').value = subscriptionSelect.querySelector('option').value;
        } 
      } else if(sellingPlanId != ""){
        if (subscriptionSelect) subscriptionSelect.classList.remove('d-none');
      }
    }

    let form = event.target.closest('form');
    let variantId = JSON.parse(form.querySelector('[name="id"]').value);
    let variantsData = JSON.parse(form.querySelector('[data-variantJSON]').innerText);
    let currentVariant = variantsData.find(item => item.id == variantId);
    
    /*let sellingPlanId = form.querySelector('[data-subscription-radio]').querySelector('[name="selling_plan"]').value;
    if(sellingPlanId != ""){ 
      var sellingPlanPrice = currentVariant.selling_plan_allocations.find(plan => plan.selling_plan_id == sellingPlanId);
    } else { 
      var sellingPlanPrice = currentVariant.price; 
    }*/

    var sellingPlanPrice = currentVariant.price;

    let currentPriceEle = form.closest('[data-product-container]')?.querySelector('[data-currentprice]');
    /*let type = form.querySelector('[name="selling_plan"]:checked')?.closest('[data-purchase_type]')?.getAttribute('data-purchase_type');
    if (type == 'onetime') { 
      currentPriceEle.innerHTML = Shopify.formatMoney(currentVariant.price,window.globalVariables.money_format);
    } else if(type == 'subscription'){ 
      currentPriceEle.innerHTML = Shopify.formatMoney(sellingPlanPrice.price,window.globalVariables.money_format); 
    }*/

    currentPriceEle.innerHTML = Shopify.formatMoney(currentVariant.price,window.globalVariables.money_format);

    /*let onetimeProductPrice = form.querySelector('[data-purchase_type="onetime"]').querySelector('[data-onetime-productPrice]');
    if(onetimeProductPrice) onetimeProductPrice.innerHTML = Shopify.formatMoney(currentVariant.price,window.globalVariables.money_format);
    let subscriptionProductPrice = form.querySelector('[data-purchase_type="subscription"]').querySelector('[data-subscription-productPrice]');
    if(subscriptionProductPrice) subscriptionProductPrice.innerHTML = Shopify.formatMoney(sellingPlanPrice.price,window.globalVariables.money_format);*/
  }

  _changeSellingPlan(event){
    let id = event.target.value;
    event.target.closest('[data-purchase_type]').querySelector('[name="selling_plan"]').value = id;
  }

  _changeCheckbox(event){
    let form = event.target.closest('form');
    let container = event.target.closest('[data-product-container]');
    let variantId = JSON.parse(form.querySelector('[name="id"]').value);
    let variantsData = JSON.parse(form.querySelector('[data-variantJSON]').innerText);
    let currentVariant = variantsData.find(item => item.id == variantId);

    if(event.currentTarget.checked){ 
      var price = Shopify.formatMoney(currentVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);
      var compare_price = Shopify.formatMoney(currentVariant.selling_plan_allocations[0].compare_at_price, window.globalVariables.money_format);
    }else{ 
      var price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format); 
      var compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    }
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');
    if (priceElement) priceElement.innerHTML = price;
    if (comparePriceElement) comparePriceElement.innerHTML = compare_price;
  }
}
customElements.define('recharge-widget', rechargeWidget);

let inputCount = 0;
    document.querySelectorAll('[data-addons-list]').forEach(input=>{
      input.addEventListener('click',event=>{
        let currentTarget = event.currentTarget
        if(currentTarget.checked == true){
          inputCount = inputCount + 1
          console.log('yes')
          document.querySelector('[data-addon-button]').removeAttribute('disabled')
        }else{
          inputCount = inputCount - 1
          if(inputCount == 0){
          document.querySelector('[data-addon-button]').setAttribute('disabled','disabled')
          }
        }
      })
    })